import { tokenStyles } from './tokens.styles.js';
import { modalStyles } from './modal.styles.js';
import { headerStyles } from './header.styles.js';
import { badgesStyles } from './badges.styles.js';
import { buttonStyles } from './button.styles.js';
import { loadingStyles } from './loading.styles.js';
import { successStyles } from './success.styles.js';
import { errorStyles } from './error.styles.js';
import { formInfoStyles } from './form-info.styles.js';
import { accordionStyles } from './accordion.styles.js';
import { tooltipStyles } from './tooltip.styles.js';
import { consentStyles } from './consent.styles.js';
import { responsiveStyles } from './responsive.styles.js';

export const typelessFormStyles = [
  tokenStyles,
  modalStyles,
  headerStyles,
  badgesStyles,
  buttonStyles,
  loadingStyles,
  successStyles,
  errorStyles,
  formInfoStyles,
  accordionStyles,
  tooltipStyles,
  consentStyles,
  responsiveStyles,
];
